import React, { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ROUTES from './../../constants/routes';
import withRouter from '../../constants/withRouter'
import './../../css/ContentViewer.css';

class ContentViewer extends Component {
    render() {
        let parentRoute = ROUTES.DATA.filter(route => route.isParent);
        parentRoute = parentRoute.length > 0 ? parentRoute[0] : null;

        let route = ROUTES.DATA.filter(route => route.path===this.props.location.pathname || (!route.isParent && this.props.location.pathname.split(route.path.split(":")[0])[0]==="")); // checking url match excluding params
        route = route.length > 0 ? route[0] : null;

        window.dispatchEvent(new CustomEvent("onRouteChanged", {'detail': {parentRoute: parentRoute, route: route}}));

        return (
            <div class="container-fluid" >

                <Routes>
                    {
                        ROUTES.DATA.map((route, i) => {
                            return(
                                <Route exact={route.isExact} path={route.path} element={<route.component {...this.props} />} key={i}></Route>
                            )
                        })
                    }
                    <Route path="*" element={<Navigate to={ROUTES.PATH.HomePage} replace/>} /> 404 route
                </Routes>
            </div>
        );
    }
}

export default withRouter(ContentViewer);
